import $ from 'jquery';
import { Alert, Modal } from 'rustig';

module Cp.Views {
  export class Users {
    public static refreshAccountStatus(data) {
      var $confirmModal = $('[data-modal-id="confirmation-modal"');
      if ($confirmModal.length != 0) {
        Modal.close();
      }
      $('[data-modal-id="user-modal"] .field-account-status').html(data.html);
      Alert.flash(data.alertMessage);
    }
  }
}